import React from 'react';

export default function Footer() {
    return (
        <div id='portFooter'>
    
            <a href="https://github.com/rainydaysgameplays" target='_Blank' rel='noreferrer' className='footerLinks'><div>Git Main</div></a>
            <a href="https://github.com/justinallenshade" target='_Blank' rel='noreferrer' className='footerLinks'><div>GA Git</div></a>
            <a href="https://www.linkedin.com/in/justin-a-shade/" target='_Blank' rel='noreferrer' className='footerLinks'><div>LinkedIn</div></a>

        </div>
    );
}

